<template>
  <div id="div-tabela-kpis-ressarcimento-by-municipio">
    <div v-if="loading" class="loading-overlay">
      <v-progress-circular indeterminate color="primary" size="32" />
    </div>
    <v-text-field
      v-if="numMunicipios > 10"
      v-model="search"
      append-icon="mdi-magnify"
      class="ml-auto mb-5 break-search"
      label="Procurar"
      hide-details
      single-line
    />
    <v-data-table
      class="data-table-kpis"
      dense
      :headers="headers"
      :items="items"
      :search="search"
      :items-per-page="10"
      no-data-text="Nenhum registro disponível"
      no-results-text="Nenhum registro correspondente encontrado"
    >
      <template
        v-for="h in headers"
        v-slot:[`header.${h.value}`]="{ header }"
      >
        <v-tooltip bottom v-if="traducaoIndicadores[h.value] != null">
          <template v-slot:activator="{ on }">
            <span v-on="on">{{ h.text }}</span>
          </template>
          <span>{{ traducaoIndicadores[h.value] }}</span>
        </v-tooltip>
        <span v-else>{{ h.text }}</span>
      </template>

      <template v-slot:[`item.qtd_inspecoes`]="{ item }">
        {{ item.qtd_inspecoes | parseNumberToFloatBrIgnoringNaN }}
      </template>
      <template v-slot:[`item.qtd_tois`]="{ item }">
        {{ item.qtd_tois | parseNumberToFloatBrIgnoringNaN }}
      </template>
      <template v-slot:[`item.qtd_tois_cobradas`]="{ item }">
        {{ item.qtd_tois_cobradas | parseNumberToFloatBrIgnoringNaN }}
      </template>
      <template v-slot:[`item.percentual_tois`]="{ item }">
        {{ item.percentual_tois | parseNumberToFloatBrIgnoringNaN }}%
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  name: "KpisByMunicipioDataTable",
  props: {
    dadosKpisByMunicipio: {
      type: Object,
      required: true,
    },
    traducaoIndicadores: {
      type: Object,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    headers: [
      {
        text: "IBGE",
        value: "codigo_municipio",
        width: "100px",
      },
      {
        text: "Município",
        value: "nome_municipio",
        width: "150px",
      },
      {
        value: "qtd_inspecoes",
        text: "Qtd. Inspeções",
        width: "120px",
      },
      {
        value: "qtd_tois",
        text: "Qtd. TOIs Emitidas",
        width: "120px",
      },
      {
        value: "qtd_tois_cobradas",
        text: "Qtd. TOIs Cobradas",
        width: "120px",
      },
      {
        value: "percentual_tois",
        text: "% TOIs",
        width: "100px",
      },
    ],
    search: "",
  }),
  computed: {
    numMunicipios() {
      return this.items ? this.items.length : 0;
    },
    items() {
      if (!this.dadosKpisByMunicipio) return [];
      return Object.entries(this.dadosKpisByMunicipio)
        .map(([nomeMunicipio, dados]) => ({
          codigo_municipio: dados.codigo_municipio,
          nome_municipio: nomeMunicipio,
          qtd_inspecoes: dados.qtd_inspecoes,
          qtd_tois: dados.qtd_tois,
          qtd_tois_cobradas: dados.qtd_tois_cobradas,
          percentual_tois: dados.percentual_tois * 100,
        }))
        .sort((a, b) => b.qtd_inspecoes - a.qtd_inspecoes);
    },
  },
  methods: {},
};
</script>

<style>
#div-tabela-kpis-ressarcimento-by-municipio {
  min-height: 420px;
  position: relative;
}
.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 420px;
}
.data-table-kpis table tbody tr td {
  font-size: 12px;
  padding: 0px 8px !important;
}
.data-table-kpis table thead tr th {
  font-size: 12px;
  height: 25px;
  font-weight: 400;
}
</style>
